import axios from 'axios';
import EnvironmentManager, { buildUrl } from '../config/EnvironmentManager';
import { getAuth } from 'firebase/auth';

const getAuthToken = async () => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    return await user.getIdToken();
  }
  return null;
};

const getHeaders = async () => {
  const token = await getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : ''
  };
};

const getZoneId = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
};

export const cartService = {
  getCart: async (userId) => {
    try {
      const headers = await getHeaders();
      const zoneId = encodeURIComponent(getZoneId());
      const response = await axios.get(
        `${buildUrl(EnvironmentManager.endpoints.cartGet, userId)}?zoneId=${zoneId}`,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching cart:', error);
      throw error;
    }
  },

  addToCart: async (userId, courseId, resourceType) => {
    try {
      const headers = await getHeaders();
      const response = await axios.post(
        `${buildUrl(EnvironmentManager.endpoints.cartAdd)}/${userId}/${courseId}?resourceType=${resourceType}`,
        {},
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  },

  removeFromCart: async (userId, courseId) => {
    try {
      const headers = await getHeaders();
      const zoneId = encodeURIComponent(getZoneId());
      const response = await axios.delete(
        `${buildUrl(EnvironmentManager.endpoints.cartRemove)}/${userId}/${courseId}?zoneId=${zoneId}`,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Error removing from cart:', error);
      throw error;
    }
  },

  clearCart: async (userId) => {
    try {
      const headers = await getHeaders();
      const zoneId = encodeURIComponent(getZoneId());
      const response = await axios.delete(
        `${buildUrl(EnvironmentManager.endpoints.cartClear, userId)}?zoneId=${zoneId}`,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Error clearing cart:', error);
      throw error;
    }
  },

  // POST /mv-profile/cart/create-checkout/{userId}
  createCheckout: async (userId) => {
    try {
      const headers = await getHeaders();
      const response = await axios.post(
        `${EnvironmentManager.baseUrl}${EnvironmentManager.endpoints.cartCreateCheckout}/${userId}`,
        {},
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating checkout:', error);
      throw error;
    }
  },

  // POST /mv-profile/cart/create-order/{userId}/{checkoutId}
  createOrder: async (userId, checkoutId) => {
    try {
      const headers = await getHeaders();
      const response = await axios.post(
        `${EnvironmentManager.baseUrl}${EnvironmentManager.endpoints.cartCreateOrder}/${userId}/${checkoutId}`,
        {},
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating Razorpay order:', error);
      throw error;
    }
  },

  // POST /mv-profile/cart/verify-payment
  verifyPayment: async ({ checkoutId, razorpayOrderId, razorpayPaymentId, razorpaySignature }) => {
    try {
      const headers = await getHeaders();
      const response = await axios.post(
        `${EnvironmentManager.baseUrl}${EnvironmentManager.endpoints.cartVerifyPayment}`,
        { checkoutId, razorpayOrderId, razorpayPaymentId, razorpaySignature },
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error('Error verifying payment:', error);
      throw error;
    }
  }
};
